import gql from 'graphql-tag';

const QUERY_MARKERS = gql`
  query Markers($cityId: String!, $filters: FiltersInput, $limit: Int) {
    search(cityId: $cityId, filters: $filters, limit: $limit) {
      totalMarkers
      markers {
        id
        coord
        instantBooking
        minimumPrice
        so
        totalCountMultilisting
      }
    }
  }
`;

const QUERY_MARKERS_BOUNDS = gql`
  query MarkersBounds(
    $cityId: String!
    $filters: FiltersInput
    $bounds: MapBounds
    $limit: Int
  ) {
    search(cityId: $cityId, filters: $filters, limit: $limit, bounds: $bounds) {
      totalMarkers
      markers {
        id
        coord
        instantBooking
        minimumPrice
        so
        totalCountMultilisting
      }
    }
  }
`;

export const getMarkersQuery = client => (cityId, filters, limit) =>
  client.query({
    query: QUERY_MARKERS,
    variables: {
      cityId,
      filters,
      limit
    }
  });

export const getMarkersBoundsQuery =
  client => (cityId, filters, bounds, limit) =>
    client.query({
      query: QUERY_MARKERS_BOUNDS,
      variables: {
        cityId,
        filters,
        bounds,
        limit
      }
    });

export default getMarkersQuery;
